import { Controller } from '@hotwired/stimulus';
import Cookies from 'js-cookie';

export default class PostPurchaseBannerController extends Controller {
  connect() {
    if (Cookies.get('from_successful_checkout')) {
      Cookies.remove('from_successful_checkout');
    }
  }

  close() {
    this.element.classList.add('is-collapsed');

    setTimeout(() => {
      this.element.remove();
    }, 1500);
  }
}
